export default __webpack_public_path__ + "static/media/cartilla_email.dc21d7f3.mp4";